export default {
  common: {
    labels: {
      onlyInstalled: "Only Installed",
      showMore: "Show More",
      showLess: "Show Less",
      reportDate: "Report Date",
      reportTime: "Report Time",
      reportAtGlance: "Report at a glance",
      fleetStatus: "Fleet Status",
      fleetSize: "Fleet Size",
      totalDevices: "Total Devices",
      addNewAlert: "Add New Alert",
      addNewRecepient: "Add New Recipient",
      selectEVModel: "Select EV Model",
      selectHPModel: "Select HP Model",
      reRunAnalysis: "Re-run Analysis",
      devicesWith: "Devices with",
      logout: "Logout",
      name: "Name",
      email: "Email",
      nickname: "Nickname",
      openAsPage: "Open as a Page",
      editDeviceDetails: "Edit Device Details",
      manageAlerts: "Manage Alerts",
      noLocation: "No location found for this device",
      selectDeviceToCompare: "Select a device to compare",
      includeAmbientTemperature: "Include Ambient Temperature",
      startDate: "Start Date",
      endDate: "End Date",
      thisFieldIsRequired: "This field is required",
      emailMustBeValid: "Email must be valid",
      mustBeLessThan50Characters: "Must be less than 50 characters",
      numberHasToBeBetween0And100: "Number has to be between 0 and 100",
      timeOfDay: "Time of Day",
      indicatesRequiredField: "Indicates Required Field",
      editDetails: "Edit Details",
      noReportAvailable: "No report is available for any week",
      noDataAvailable: "No data available",
      valueShouldBeGreaterThan: "Value should be greater than",
      valueShouldBeLessThan: "Value should be less than",
      resetView: "Reset View",
      fleetOverview: "Fleet Overview",
      functionalLocation: "Functional Location",
    },
    words: {
      total: "Total",
      this: "This",
      all: "All",
      watchList: "Watchlist",
      schedule: "Schedule",
      client: "Client",
      recepients: "Recepients",
      more: "More",
      devices: "Devices",
      search: "Search",
      reset: "Reset",
      save: "Save",
      language: "Language",
      english: "English",
      french: "French",
      back: "Back",
      clear: "Clear",
      to: "to",
      standart: "Standart",
      commuter: "Commuter",
      nonCommuter: "Non Commuter",
      edit: "Edit",
      cancel: "Cancel",
      saveAs: "Save As",
      alert: "Alert",
      last: "Last",
      preferences: "Preferences",
    },
    messages: {
      success: {
        deviceDetailsSaved: "Device Details Successfully Saved!",
        good: "Good",
      },
      warnings: {
        temperatureError: "Temperature Error",
        temperatureInvestigationWarning: "Assets with temperature alert that may require investigation",
        missedMessages: "Missed Messages",
        noCommunications: "No Communications",
      },
      errors: {},
      filter: {
        filterApplied: "Filter applied successfully",
        filterRemoved: "Filter removed successfully",
        filterError: "Error while applying filter",
      },
    },
    measure: {
      kVA: "kVA",
      kW: "kW",
    },
    times: {
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      months: {
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        november: "November",
        december: "December",
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        my: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        nov: "Nov",
        dec: "Dec",
      },
      time: {
        today: "Today",
        second: "Second",
        seconds: "Seconds",
        minute: "Minute",
        minutes: "Minutes",
        hr: "Hour",
        hrs: "Hours",
        day: "Day",
        days: "Days",
        week: "Week",
        weeks: "Weeks",
        month: "Month",
        months: "Months",
        year: "Year",
        years: "Years",
        secondsAge: "Seconds Ago",
        minutesAge: "Minutes Ago",
        hoursAgo: "Hours Ago",
        daysAgo: "Days Ago",
        weeksAgo: "Weeks Ago",
        monthsAgo: "Months Ago",
        yearsAgo: "Years Ago",
        last24Hours: "Last 24 Hours",
        last7Days: "Last 7 Days",
        last28Days: "Last 28 Days",
        lastWeek: "Last Week",
        last4Weeks: "Last 4 Weeks",
        last8Weeks: "Last 8 Weeks",
        last3Months: "Last 3 Months",
        last6Months: "Last 6 Months",
        last1Year: "Last 1 Year",
        TwentyFourHours: "24 Hours",
        SevenDays: "7 Days",
        TwentyEightDays: "28 Days",
      },
    },
  },
  views: {
    Alerts: {},
    RolloutDashboard: {
      mainTitle: "Rollout Dashboard",
      pageTitle: "Overview",
      charts: {
        deviceStatus: {
          title: "Installation Over Time",
        },
        overview: {
          title: "Overview",
        },
        plannerGroup: {
          title: "Planner Group",
        },
        statusUpdate: {
          title: "Total Devices",
        },
        siteStatusUpdate: {
          title: "Total Sites",
        },
      },
      tables: {
        devices: {
          title: "Devices",
        },
        plannerGroups: {
          title: "Planner Groups",
        },
        sites: {
          title: "Sites",
        },
      },
    },
    Analytics: {
      mainTitle: "Analytics",
      pageTitle: "Overview",
      charts: {
        totalPower: {
          title: "Total Power",
          xLabel: "Capacity (kVA)",
          yLabel: "Timestamp",
          bottomLabelMaxCapacity: "Total Max Capacity",
          bottomLabelTotalCapacity: "Total Capacity Used",
        },
        issues: {
          title: "Issues",
          xLabel: "Issues",
          yLabel: "Number of Devices",
          hAxis: {
            HasCapacityUnderLimit: {
              label: "Capacity UnderLimit",
              tooltip: "Assets with capacity less than 15%",
            },
            HasCapacityOverLimit: {
              label: "Capacity OverLimit",
              tooltip: "Assets with capacity more than 85%",
            },
            HasMissedMessages: {
              label: "Missed Messages",
              tooltip: "Assets with missed messages.",
            },
            HasImbalance: {
              label: "Phase Imbalance",
              tooltip: "Assets with max imbalance > 90%",
            },
            HasCurrentOverLimit: {
              label: "Current OverLimit",
              tooltip: "Assets with current overlimit",
            },
            HasLowBattery: {
              label: "Low Battery",
              tooltip: "Assets with low battery.",
            },
            HasNoPower: {
              label: "No Power",
              tooltip: "Assets with no power",
            },
            HasTemperatureOutsideRange: {
              label: "Temperature Outside Range",
              tooltip: "Assets with temperature outside range",
            },
            HasTemperatureOverLimit: {
              label: "Temperature OverLimit",
              tooltip: "Assets with temperature overlimit",
            },
            HasTemperatureSenseError: {
              label: "Temperature Alert",
              tooltip: "Assets with temperature alert",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "Devices",
          columns: {
            id: "Device ID",
            type: "Monitor Type",
            t_name: "Transformer Name",
            t_size: "Transformer Size",
            capacity: {
              text: "Capacity",
              tooltip: "% of total available capacity in use. (Total Median Current * 230/1000) / PowerRating (%)",
            },
            power: {
              text: "Total Power",
              tooltip: "The total combined maximum power measurements of all phases measured during the period.",
            },
            l_message: "Last Message",
          },
        },
      },
    },
    Asset: {
      deviceDetails: {
        transformerName: {
          label: "Transformer Name",
        },
        transformerNo: {
          label: "Transformer  No.",
        },
        transformerSize: {
          label: "Transformer Size",
        },
        assetId: {
          label: "Asset ID",
        },
        deviceStatus: {
          label: "Device Status",
        },
        deviceVoltage: {
          label: "Device Voltage",
        },
        installationDate: {
          label: "Installation Date",
        },
        connectedMPRNs: {
          label: "Connected MPRNs",
        },
        commuterArea: {
          label: "Commuter Area",
        },
      },
      latestMessage: {
        title: "Latest Message",
        currentPH1: {
          label: "Current PH1",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        currentPH2: {
          label: "Current PH2",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        currentPH3: {
          label: "Current PH3",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        temperature: {
          label: "Temperature",
          suffix: "°C",
          helptext: "(Med/Max)",
        },
      },
      calculatedReadings: {
        title: "Calculated Readings",
        totalPower: {
          label: "Total Power",
          suffix: "kVA",
        },
        capacity: {
          label: "Capacity",
          suffix: "%",
        },
        imbalance: {
          label: "Imbalance",
          suffix: "%",
        },
        utilization: {
          label: "Utilization",
          suffix: "%",
        },
      },
      tabs: {
        charts: {
          label: "Charts",
        },
        messages: {
          label: "Messages",
        },
        evAnalysis: {
          label: "EV Analysis",
        },
        hpAnalysis: {
          label: "HP Analysis",
        },
      },
      charts: {
        chartConfig1: {
          title: "Select device to compare",
          temp: {
            label: "Temperature (°C)",
            xAxis: "TimeStamp",
            yAxis: "Temperature (°C)",
          },
          diff: {
            label: "Temperature (°C)",
            xAxis: "TimeStamp",
            yAxis: "Temperature",
          },
          imbalance: {
            label: "Imbalance and Current Medians(A)",
            labelDailyStats: "Imbalance and Current(A)",
            xAxis: "TimeStamp",
            yAxis: "Max Load (A)",
            yBarAxis: "Imbalance (%)",
          },
          totalPower: {
            label: "Total Power and Current Medians(A)",
            labelDailyStats: "Total Power and Current(A)",
            xAxis: "TimeStamp",
            yAxis: "Max Load (A)",
            yBarAxis: "Total Power (kVA)",
          },
          imbalanceMax: {
            label: "Imbalance and Current Maximum(A)",
            xAxis: "TimeStamp",
            yAxis: "Max Load",
            yBarAxis: "Imbalance",
          },
          totalPowerMax: {
            label: "Total Power and Current Maximum(A)",
            xAxis: "TimeStamp",
            yAxis: "Max Load (A)",
            yBarAxis: "Total Power (kVA)",
          },
        },
      },
      tables: {
        messages: {
          columns: {
            seqNo: {
              text: "Seq No",
            },
            messageTime: {
              text: "Message Time",
            },
            missedMessage: {
              text: "Missed Message",
            },
            lqi: {
              text: "LQI",
            },
            medCurrentPH1: {
              text: "Med Current PH1",
              suffix: "A",
            },
            maxCurrentPH1: {
              text: "Max Current PH1",
              suffix: "A",
            },
            medCurrentPH2: {
              text: "Med Current PH2",
              suffix: "A",
            },
            maxCurrentPH2: {
              text: "Max Current PH2",
              suffix: "A",
            },
            medCurrentPH3: {
              text: "Med Current PH3",
              suffix: "A",
            },
            maxCurrentPH3: {
              text: "Max Current PH3",
              suffix: "A",
            },
            maxTemp: {
              text: "Max Temp.",
              suffix: "°C",
            },
            medTemp: {
              text: "Med Temp.",
              suffix: "°C",
            },
            capacity: {
              text: "Capacity",
              suffix: "%",
              tooltip: "% of total available capacity in use. (Total Median Current * 230/1000) / PowerRating (%)",
            },
            imbalance: {
              text: "Imbalance",
              suffix: "%",
              tooltip:
                "Current imbalance between phases. Max Difference between phase and Avg Current / Avg Current (%) *for 3 phase only",
            },
          },
        },
      },
    },
    // Text templates of Assets view.
    Assets: {
      pageTitle: "Devices Overview",
      deviceCoverage: "Check Device Coverage",
      charts: {
        capacity: {
          title: "Capacity",
          tooltip:
            "Capacity analysis measures the amount of capacity in use at each transformer and stratifies by overutilized, normal or underperforming.",
          header: {
            capacity: "Capacity",
            numberOfDevices: "Number of Devices",
          },
          data: {
            underperforming: {
              text: "Underperforming",
              message: "Devices under current limit - Less than 15% Capacity",
            },
            normal: {
              text: "Normal",
              message: "Devices with optimal current - Inbetween 15% and 85% Capacity",
            },
            overutilised: {
              text: "Overutilised",
              message: "Devices over current limit - More than 85% Capacity",
            },
          },
        },
        imbalance: {
          title: "Imbalance",
          tooltip:
            "Imbalance measures the amount of imbalance across all the 3 phases in use at each transformer and stratifies by imbalance or normal.",
          header: {
            imbalanceStatus: "Imbalance Status",
            numberOfDevices: "Number of Devices",
          },
          data: {
            normal: {
              label: "Normal",
              message: "Devices with no imbalance.",
            },
            imbalance: {
              label: "Imbalance",
              message: "Devices with imbalance.",
            },
          },
        },
        powerChange: {
          title: "Power Change",
          tooltip:
            "Power change measures the amount of power change at each transformer and stratifies by abnormal or normal.",
          header: {
            powerChangeStatus: "Power Change Status",
            numberOfDevices: "Number of Devices",
          },
          data: {
            normal: {
              label: "Normal",
              message: "Devices with no abnormal power change.",
            },
            abnormal: {
              label: "Abnormal",
              message: "Devices with abnormal power change.",
            },
          },
        },
        batteryStatus: {
          title: "Battery Status",
          tooltip: "Displays battery status of all devices and stratifies by high, low or unknown.",
          header: {
            batteryStatus: "Battery Status",
            numberOfDevices: "Number of Devices",
          },
          data: {
            highBattery: {
              label: "High Battery",
              message: "Devices with high battery.",
            },
            lowBattery: {
              label: "Low Battery",
              message: "Devices with low battery.",
            },
            unknownBattery: {
              label: "Unknown Battery",
              message: "Devices with unknown battery.",
            },
          },
        },
        devicesCommunication: {
          title: "Devices Communication",
          tooltip:
            "Displays communication of all devices and stratifies by communicated, no communication or missed messages.",
          header: {
            connectivity: "Connectivity",
            numberOfDevices: "Number of Devices",
          },
          data: {
            communicated: {
              label: "Communicated",
              message: "Devices with no missed messages",
            },
            noCommunications: {
              label: "No Communication",
              message: "Devices not communicated in last 24 hours",
            },
            missedMessages: {
              label: "Missed Messages",
              message: "Devices with missed messages",
            },
          },
        },
        devicesStatus: {
          title: "Devices Status",
          tooltip:
            "Displays status/issues of all devices and stratifies by no issue, imbalance problem, temperature outside range, current overlimit, communication problem, power problem, temp. sense problem, temp. overLimit or battery problem.",
          header: {
            deviceStatus: "Device Status",
            numberOfDevices: "Number of Devices",
          },
          data: {
            noIssue: {
              label: "No Issue",
              message: "Devices with no issues.",
            },
            phaseImbalance: {
              label: "Phase Imbalance",
              message: "Devices with max imbalance > 90%",
            },
            temperatureAlert: {
              label: "Temperature Alert",
              message: "Devices with temeperature alert that may require investigation",
            },
            currentOverlimit: {
              label: "Current Overlimit",
              message: "Devices with current overlimit.",
            },
            communicationProblem: {
              label: "Communication Problem",
              message: "Devices with communication issue.",
            },
            noPower: {
              label: "No Power",
              message: "Devices with power problem.",
            },
            lowBattery: {
              label: "Low Battery",
              message: "Devices with battery issues.",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "",
          filters: {
            primary: {},
            secondary: {
              list_checkbox: {
                label: "Transformer Type",
              },
              flags: {
                temperatureOverlimit: {
                  label: "Temperature Overlimit",
                },
                currentOverlimit: {
                  label: "Current Overlimit",
                },
              },
              range: {
                transformerSize: {
                  label: "Transformer Size",
                },
                maxCurrentPH1: {
                  label: "Maximum Current PH1",
                },
                maxCurrentPH2: {
                  label: "Maximum Current PH2",
                },
                maxCurrentPH3: {
                  label: "Maximum Current PH3",
                },
                maxTemperature: {
                  label: "Maximum Temperature",
                },
              },
            },
          },
          columns: {
            deviceId: {
              text: "Device ID",
            },
            monitorType: {
              text: "Monitor Type",
            },
            deviceName: {
              text: "Name",
            },
            powerRating: {
              text: "T. Size",
            },
            totalPower: {
              text: "Total Power",
              tooltip: "The total combined maximum power measurements of all phases measured during the period.",
            },
            maxCapacity: {
              text: "Max Capacity (%)",
              tooltip: "% of total available capacity in use. (Total Max Current * 230/1000) / PowerRating (%)",
            },
            maxImbalance: {
              text: "Max Imbalance (%)",
              tooltip:
                "Current imbalance between phases. Max Difference between phase and Avg Current / Avg Current (%) *for 3 phase only",
            },
            current0Max: {
              text: "Max Current PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Max Temp.",
            },
            isCommuterArea: {
              text: "Commuter Area",
            },
            isWatchlisted: {
              text: "",
            },
            moreActions: {
              text: "",
              editDetails: "Edit Details",
            },
          },
        },
      },
    },
    AssetSnapshotView: {},
    CoverageChecker: {},
    Device: {},
    DeviceCoverage: {},
    DeviceHome: {},
    Error: {},
    EVModelling: {
      charts: {
        maxEVSupported: {
          title: "Max EVs Supported",
          labels: {
            maxEVs: "Max EVs",
            numberOfDevices: "Number of Devices",
          },
        },
        maxHPSupported: {
          title: "Max HP Supported",
          labels: {
            maxHP: "Max HPs",
            numberOfDevices: "Number of Devices",
          },
        },
        firstYearOverCapacity: {
          title: "First Year Over Capacity",
          labels: {
            xLabel: "First Year of Problem",
            yLabel: "No. of Devices",
          },
        },
      },
      tables: {
        deviceEVMTable: {
          title: "",
          columns: {
            deviceId: {
              text: "Device ID",
            },
            maxEVs: {
              text: "Max. EVs",
            },
            maxEVHour: {
              text: "Max EVs Hour",
            },
            firstYearOverCapacity: {
              text: "First Year Over Capacity Combined",
            },
            maxLoadDay: {
              text: "MaxLoadDay",
            },
            minHeadroom: {
              text: "MinHeadroom",
            },
            maxLoad: {
              text: "MaxLoad",
            },
            maxLoadHour: {
              text: "MaxLoadHour",
            },
          },
        },
      },
    },
    Home: {},
    HPModelling: {},
    Journey: {},
    Journeys: {},
    Location: {},
    LocationList: {},
    PoiReport: {},
    PowerdataAlerts: {
      title: "",
      tabs: {
        activeAlerts: {
          label: "Active Alerts",
        },
        manageAlerts: {
          label: "Manage Alerts",
        },
      },
      alert: {
        alarm: {
          label: "Alarm",
        },
        maxCurrentPH1: {
          label: "Max Current PH1",
        },
        medCurrentPH1: {
          label: "Med Current PH1",
        },
        maxCurrentPH2: {
          label: "Max Current PH2",
        },
        medCurrentPH2: {
          label: "Med Current PH2",
        },
        maxCurrentPH3: {
          label: "Max Current PH3",
        },
        medCurrentPH3: {
          label: "Med Current PH3",
        },
        maxTemperature: {
          label: "Max Temperature",
        },
        medTemperature: {
          label: "Med Temperature",
        },
        imbalance: {
          label: "Imbalance",
        },
        totalPower: {
          label: "Total Power",
        },
      },
      tables: {
        alerts: {
          columns: {
            alertId: {
              text: "Alert ID",
            },
            deviceId: {
              text: "Device ID",
            },
            deviceType: {
              text: "Device Type",
            },
            triggerField: {
              text: "Trigger Field",
            },
            triggerValue: {
              text: "Trigger Value",
            },
            triggerOperator: {
              text: "Trigger Operator",
            },
            moreActions: {
              text: "",
              labels: ["Manage Recipients", "Edit Details", "Delete"],
            },
          },
        },
        activeAlerts: {
          columns: {
            alertId: {
              text: "Alert ID",
            },
            deviceId: {
              text: "Device ID",
            },
            fullName: {
              text: "Name",
            },
            deviceType: {
              text: "Device Type",
            },
            triggerField: {
              text: "Trigger Field",
            },
            triggerValue: {
              text: "Trigger Value",
            },
            actualValue: {
              text: "Actual Value",
            },
            triggerDate: {
              text: "Trigger Date",
            },
          },
        },
      },
    },
    PowerdataReports: {
      header: {},
    },
    PowerdataReportView: {},
    Profile: {
      userInformation: {
        title: "User Information",
      },
      preferences: {
        language: "Language Preference",
        theme: "Theme Preference",
      },
      managePreferences: {
        title: "Manage Preferences",
        defaultTab: "Default Tab",
        manageSections: "Manage Sections",
        arrangeSections: "Arrange Sections",
        manageScavengerTabs: "Manage Scavenger Tabs",
        manageScavengerAlerts: "Scavenger Alerts",
        manageSentinelTabs: "Manage Sentinel Tabs",
        manageSentinelAlerts: "Sentinel Alerts",
        manageEventNotifications: "Scavenger Events",
      },
    },
    Reports: {},
    ScavengerAsset: {},
    ScavengerAssets: {},
    ScavengerOverview: {
      title: "Overview",
      tabs: {
        all: {
          label: "Device(s) ",
        },
        nz: {
          label: "Device(s) with ",
        },
        pq: {
          label: "Device(s) with ",
        },
        th: {
          label: "Device(s) with ",
        },
        h2: {
          label: "Device(s) with ",
        },
      },
    },
    ScavengerH2: {
      title: "Overview",
      tabs: {
        alarm: {
          label: "Alarm",
        },
        caution: {
          label: "Caution",
        },
        checkDevice: {
          label: "Check Device",
        },
        noIssues: {
          label: "No Issues",
        },
      },
      tables: {
        devices: {
          columns: {
            deviceId: {
              text: "ID",
            },
            h2Level: {
              text: "H₂ Level",
            },
            xfmrId: {
              text: "XFMR ID",
            },
            site: {
              text: "SITE",
            },
            oilType: {
              text: "Liquid TYPE",
            },
            opMode: {
              text: "OP MODE",
            },
            lastReading: {
              text: "LAST READING",
            },
          },
        },
      },
    },
    ScavengerH2Details: {
      deviceDetails: {
        site: {
          label: "Site",
        },
        xfmrId: {
          label: "XFMR ID",
        },
        serialNumber: {
          label: "Serial Number",
        },
        opMode: {
          label: "Op Mode",
        },
        oilType: {
          label: "Liquid Type",
        },
        deviceStatus: {
          label: "Device Status",
        },
        lastStatusUpdate: {
          label: "Installed Date",
        },
        alarmLimit: {
          label: "Alarm Limit",
        },
        cautionLimit: {
          label: "Caution Limit",
        },
        sensorType: {
          label: "Sensor Type",
        },
        sensorLocation: {
          label: "Sensor Location",
        },
      },
      latestMessage: {
        title: "Latest Message",
        labels: {
          h2Level: {
            label: "H₂ Lvl",
          },
          oilTemperature: {
            label: "Liquid Temperature",
          },
          pcbTemperature: {
            label: "Internal Sensor Temperature",
          },
        },
      },
      tabs: {
        charts: {
          label: "Charts",
        },
        messages: {
          label: "Messages",
        },
        gasAnalysis: {
          label: "Gas Analysis",
        },
      },
      charts: {
        h2Charts: {
          h2LevelandOilTemperature: {
            label: "Hydrogen Lvl (ppm) & Liquid Temperature",
            label_daily_stats: "Hydrogen Lvl (ppm) & Liquid Temperature",
            xAxis: "TimeStamp",
            yAxis: "Hydrogen Lvl (ppm)",
            yLineAxis: "Liquid Temperature",
            yLabel: "Hydrogen Lvl",
            hydrogen: "Hydrogen",
            oilTemperature: "Liquid Temperature",
          },
          liquidTemperature: {
            label: "Liquid Temperature (°C)",
            label_daily_stats: "Liquid Temperature (°C)",
            xAxis: "TimeStamp",
            yAxis: "Liquid Temperature", //Dynamically assign suffix based on user type
            liquidTemperature: "Liquid Temperature",
          },
          rateOfChange: {
            label: "Rate of Change",
            label_daily_stats: "Rate of Change",
            xAxis: "TimeStamp",
            yAxis: "Rate of Change",
          },
        },
        h2LongerPeriodCharts: {
          h2LevelandOilTemperature: {
            label: "Hydrogen Lvl (ppm) & Liquid Temperature (°C)",
            label_daily_stats: "Hydrogen Lvl (ppm) & Liquid Temperature (°C)",
            xAxis: "TimeStamp",
            yAxis: "Hydrogen Lvl (ppm) & Liquid Temperature (°C)",
            yLineAxis: "Liquid Temperature (°C)",
            yLabel: "Hydrogen Lvl & Liquid Temperature",
            hydrogen: "Hydrogen",
            oilTemperature: "Liquid Temperature",
          },
        },
      },
      tables: {
        messages: {
          seqNo: {
            text: "Seq No",
          },
          messageTime: {
            text: "Message Time",
          },
          h2Level: {
            text: "H₂Lvl",
          },
          oilTemperature: {
            text: "Liquid Temp",
          },
          pcbTemperature: {
            text: "PCBTemp",
          },
        },
      },
    },
    Snapshot: {},
  },
  components: {
    AlertsTemplate: {
      labels: {
        deviceType: "Device Type",
        triggerField: "Trigger Field",
        triggerValue: "Trigger Value",
        device: "Device",
        triggerOperator: "Trigger Operator",
      },
    },
    ScavengerAlertsTemplate: {
      labels: {
        triggerField: "Trigger Field",
        triggerValue: "Trigger Value",
        device: "Device",
        xfmrId: "XFMR ID",
        deviceId: "Device ID",
        triggerOperator: "Trigger Operator",
      },
    },
    AreaChartVT: {},
    AssetSnapshot: {},
    ColumnChartVT: {},
    ComboChart: {},
    ComboChartVT: {},
    DataTableVT: {},
    DaysSelector: {},
    DialogVT: {
      contactVT: "Please contact VT...",
      desc: "You have limited access to features available in the application. Please contact VT to know more about features offered.",
    },
    DiffAreaChart: {},
    DiffAreaChartVT: {},
    DiffChart: {},
    DiffColumnChartVT: {},
    DistributionBarVT: {},
    EditAssetDetails: {},
    EditLocationDetails: {},
    Error: {},
    EVModelDetails: {},
    EVModelEditDetails: {
      labels: {
        selectModel: "Select Model",
        selectDayType: "Select Day Type",
        useCommuterStatus: "Use Commuter Status",
        mostRecentWeekday: "Most recent Weekday",
        maxAnnualLoadDay: "Max Annual Load Day",
        mostRecentWeekdayTooltip: "* For which there is 24 hours of message data",
        evModelDetails: "EV Model Details",
        chooseModelName: "Choose Model Name",
        modelName: "*Model Name",
        indicatesRequiredField: "*Indicates required field",
        chargeRateWeekday: "Charge Rate (Weekday)",
        chargeDurationWeekday: "Charge Duration, Weekday (Hrs)",
        chargeDurationWeekend: "Charge Duration, Weekend (Hrs)",
        ratioOfHigh1: "Ratio of High (7Kw) to Low (3Kw) power chargers (%) [per EV = ",
        ratioOfHigh2: " kVa]",
        ratioOfBEV: "Ratio of BEV to PHEV Vehicles (%)",
        confidenceLevel: "Confidence level % (Binomial disribution)",
        percentageOfPeopleWhoPurchase: "Percentage of people who purchase a new car per year (%)",
        modifyProbalities: "Modify Probabilities",
        changeProbabilityDistribution: "Change Probability Distribution",
      },
      charts: {
        evForecast: {
          title: "Predicted proportion of EV car sales per year (to 2030)",
          label: "EV Sales Forecast",
          xAxis: "Year",
          yAxis: "% Electric Vehicle",
          vAxes: {
            title: "EV Sales (%)",
          },
          hAxis: {
            title: "Year",
          },
        },
        cumulProbChart: {
          title: "Probability an EV charger will be drawing load per hour",
          label: "Cumulative Probability Analysis",
          xAxis: "Hour of Day",
          yAxis: "Probability of Charging",
          vAxes: {
            title: "Probability of Charging",
          },
          chartLabels: {
            0: "Timestamp",
            1: "Charging Probability (%)",
          },
        },
        powerLoadDataOnly: {
          title: {
            1: "Transformer Load / Headroom analysis [ ",
            2: " ]",
          },
          label: "Transformer Load",
          yLabel: "Hour of Day",
          xLabel: "Load (kVa)",
          vAxes: {
            0: { title: "Load (kVa)" },
            1: { title: "Headroom (kVa)" },
          },
          chartLabels: {
            0: { title: "Hour Of Day" },
            1: { title: "Total Load" },
            2: { title: "Headroom" },
            3: { title: "Max Load" },
          },
        },
        evModelChart: {
          title: "Maximum additional EVs on this transformer (Binomial distribution analysis)",
          label: "EV Headroom Analysis",
          xAxis: "Hour of Day",
          yAxis: "#EV Chargers",
          vAxes: {
            0: { title: "#EV Chargers" },
            1: { title: "MAX_EVS = " },
          },
          chartLabels: {
            0: { title: "Timestamp" },
            1: { title: "Max number of chargers" },
            2: { title: "Max EVs" },
          },
        },
        totalNewEVCharge: {
          title: "Predicted New EVs Per Year on this transformer",
          label: "EV Calculated Yearly Sales",
          xAxis: "Year",
          yAxis: "# Total New EV Chargers",
          vAxes: {
            title: "# Total New EV Chargers",
          },
          hAxis: {
            title: "Year",
          },
          chartLabels: {
            0: { title: "Year" },
            1: { title: "Number of EVs" },
            2: { title: "First year over capacity" },
          },
        },
      },
    },
    FleetReport: {},
    Hero: {},
    HomeContent: {},
    HPModelEditDetails: {
      filters: {
        modelName: {
          label: "Select Model",
        },
        dayType: {
          label: "Select Day Type",
          tooltip: "Choose most recent day, or worst load day for the year",
          mostRecentWeekday: "Most recent Weekday",
          maxAnnualLoadDay: "Max Annual Load Day",
          mostRecentWeekdayTooltip: "* For which there is 24 hours of message data",
        },
        extremeScenerio: {
          label: "Extreme Scenerio ('1 in 20')",
          tooltip: "Models for unusually cold 'winter peak' (e.g. -5 degrees)",
        },
      },
      title: "HP Model Details",
      subTitle: "Model Name",
      HPModelEdit: {
        labels: {
          chooseModelName: "Choose Model Name",
          ratioOfNewBuildExistingHomes: {
            title: "Ratio of New Build Existing homes (%)",
            labelA: "New Build",
            labelB: "Existing",
          },
          ratioOfDetachedvsSemi: {
            title: "Ratio of Detached vs Semi or Terraced homes (%)",
            labelA: "Detached",
            labelB: "Semi/Terr",
          },
          ratioOfHybridvsAir: {
            title: "Ratio of Hybrid vs Air Source HP (%)",
            labelA: "Hybrid",
            labelB: "ASHP",
          },
          ratioOfHighTemp: {
            title: "Ratio of High Temp (HT) vs Low Temp (LT) Air source HP(%)",
            labelA: "HT",
            labelB: "LT",
          },
          percentageOfPeopleWhoInstall: {
            title: "Percentage of people who install a heat pump per year (%)",
            labelA: "Probability",
          },
        },
      },
      charts: {
        loadProfiles: {
          title: "Typical Load Profiles (kW) of Heat pumps per house and heat pump type",
          label: "HP Load Profiles",
          xAxis: "Hour of Day",
          yAxis: "HP Load (kW)",
          vAxes: {
            0: { title: "HP Load (kW)" },
          },
        },
        HPLoadChart: {
          title: "Estimated Load Profile (kVA) of heat pump per model",
          label: "HP Load Analysis",
          xAxis: "Hour of Day",
          yAxis: "HP Load (kVA)",
          vAxes: {
            0: { title: "HP Load (kVA)" },
          },
          labelA: "Timestamp",
          labelB: "HP Load (KVa)",
        },
        powerModel: {
          title: {
            0: "Transformer Load / Headroom analysis [",
            1: " ]",
          },
          label: "Transformer Load",
          xAxis: "Hour of Day",
          yAxis: "Load (kVa)",
          data: {
            0: "Timestamp",
            1: "Load (KVa)",
          },
          vAxes: {
            0: { title: "Load (kVa)" },
            1: { title: "Headroom (kVa)" },
          },
          labelA: "Hour of Day",
          labelB: "Total Load",
          labelC: "Headroom",
        },
        HPModel: {
          title: "Maximum additional HPs on this transformer",
          label: "HP Headroom Analysis",
          xAxis: "Hour of Day",
          yAxis: "# Heat Pumps",
          vAxes: {
            0: { title: "# Heat Pumps" },
            1: { title: "MAX_HPS = " },
          },
          labelA: "Timestamp",
          labelB: "Max number of heat pumps",
        },
        HPCalculatedSales: {
          title: "Predicted New HPs Per Year on this transformer",
          label: "HP Calculated Yearly Sales",
          xAxis: "Year",
          yAxis: "# Total New Heat Pumps",
          vAxes: {
            0: { title: "# Total New Heat Pumps" },
          },
          hAxis: {
            title: "Year",
          },
          labelA: "Year",
          labelB: "Number of HPs",
        },
      },
    },
    InputSelectVT: {},
    KPIReport: {},
    LineChart: {},
    LineChartVT: {},
    LoaderVT: {},
    MapInfoWindow: {},
    MapInfoWindowPowerdataTemplate: {},
    MapInfoWindowTemplate: {},
    MapMarkerVT: {},
    MapsVT: {},
    MapTooltipVT: {},
    MinMaxChart: {},
    NavBar: {},
    OverviewCardsVT: {},
    PageHeader: {},
    POISnapshot: {},
    PowerDataMainReport: {
      title: "Here is today's report from VT Electron",
      tables: {
        fleetStatus: {
          title: "Fleet Status",
          columns: {
            issue: {
              text: "Issue",
            },
            numberOfAssets: {
              text: "Number of Assets",
            },
            percentageDevices: {
              text: "%",
            },
          },
        },
        devices: {
          columns: {
            name: {
              text: "Transformer Name",
            },
            transformerSize: {
              text: "Transformer Size",
            },
            maxCapacity: {
              text: "Max Capacity",
            },
            maxCurrent: {
              text: "Max Current PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Max Temp.",
            },
            graph: {
              text: "",
            },
          },
        },
      },
    },
    PrimaryFiltersVT: {},
    RadialChartVT: {},
    ReportManagement: {},
    ScavengerCharts: {},
    SecondaryFiltersVT: {},
    SelectVT: {},
    SnackBarVT: {},
    TooltipVT: {},
  },
};
